import React from 'react';
import styles from './Buttons.module.css';
import { Link } from 'react-router-dom';

const Buttons = ({
  text,
  to,
  handleOnClick,
  icon,
  width,
  rounded,
  color,
  style,
  type,
  iconWidth = '',
  iconHeight = '',
  iconStyle
}) => {
  return (
    <>
      {'submit' === type ? (
        <button
          onClick={handleOnClick}
          className={styles[rounded ? 'aud-button-rounded' : 'aud-button']}
          type={type}
          style={{
            width: width,
            borderRadius: rounded ? '25px' : '0px',
            backgroundColor: color ? color : '#0DA06E',
            ...style,
          }}
        >
          {icon && (
            <img src={icon} alt="Icon" className={styles['button-icon']} style={iconStyle} />
          )}
          <span className={styles['custom-button-text']}>{text}</span>
        </button>
      ) : (
        <Link
          to={to}
          style={{
            textDecoration: 'none',
          }}
        >
          <button
            onClick={handleOnClick}
            className={styles[rounded ? 'aud-button-rounded' : 'aud-button']}
            style={{
              width: width,
              borderRadius: rounded ? '45px' : '0px',
              backgroundColor: color ? color : 'rgba(13, 160, 110, 1)',
              ...style,
            }}
          >
            {icon && (
              <img
                src={icon}
                alt="Icon"
                className={styles['button-icon']}
                style={{
                  width: iconWidth + 'px',
                  height: iconHeight + 'px',
                  ...iconStyle
                }}
              />
            )}
            <span className={styles['custom-button-text']}>{text}</span>
          </button>
        </Link>
      )}
    </>
  );
};

export default Buttons;
